import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "app/store";
import type {
  ChartNoteCompletionChunk,
  TextTemplateCompletionChunk,
} from "hooks/use-clinic-notifications";
import { sanitizeHTML } from "utils/common";
import { joinChunks } from "./util";

interface NotificationState {
  textTemplateCompletionChunk: TextTemplateCompletionChunk[];
  chartNoteCompletionChunk: ChartNoteCompletionChunk[];
}

const initialState: NotificationState = {
  textTemplateCompletionChunk: [],
  chartNoteCompletionChunk: [],
};

export const notificationsSlice = createSlice({
  name: "notifications",
  initialState,
  reducers: {
    addTextTemplateCompletionChunk: (
      state,
      action: PayloadAction<TextTemplateCompletionChunk>
    ) => {
      const { type, message } = action.payload;
      state.textTemplateCompletionChunk =
        state.textTemplateCompletionChunk.concat({
          type,
          message,
        });
    },
    resetTextTemplateCompletionChunk: (state) => {
      state.textTemplateCompletionChunk = [];
    },

    addChartNoteCompletionChunk: (
      state,
      action: PayloadAction<ChartNoteCompletionChunk>
    ) => {
      const { type, message } = action.payload;
      state.chartNoteCompletionChunk = state.chartNoteCompletionChunk.concat({
        type,
        message,
      });
    },
    resetChartNoteCompletionChunk: (state) => {
      state.chartNoteCompletionChunk = [];
    },
  },
});

export const {
  addTextTemplateCompletionChunk,
  resetTextTemplateCompletionChunk,
  addChartNoteCompletionChunk,
  resetChartNoteCompletionChunk,
} = notificationsSlice.actions;
export default notificationsSlice.reducer;

const notificationsSelector = (state: RootState) => state.notifications;

export const selectTextTemplateCompletionChunkPreview = createSelector(
  notificationsSelector,
  (notifications) =>
    sanitizeHTML(joinChunks(notifications.textTemplateCompletionChunk))
);

export const selectChartNoteCompletionChunkPreview = createSelector(
  notificationsSelector,
  (notifications) =>
    sanitizeHTML(joinChunks(notifications.chartNoteCompletionChunk))
);

export const selectCompletionChunkPreview = createSelector(
  notificationsSelector,
  (notifications) =>
    [
      sanitizeHTML(joinChunks(notifications.chartNoteCompletionChunk)),
      sanitizeHTML(joinChunks(notifications.textTemplateCompletionChunk)),
    ].join(" ")
);
